import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { UI } from '@/lib/Constants'
import {
    selectOpenSendToPosOptionsModal,
    setOpenSendToPosOptionsModal,
    setOpenCheckSelectModal,
    setOpenServerSelectModal,
} from '@/features/EditBooking/editBookingSlice'

export default function SendToPosOptionsModal() {

    const dispatch = useDispatch()
    const open     = useSelector(selectOpenSendToPosOptionsModal)

    const handleKeyDown = (e) => {
        if (
            e.key === 'Escape' &&
                !document.body.classList.contains(UI.classes.CONFIRMATION_OPEN) &&
                !document.body.classList.contains(UI.classes.HELPJUICE_OPEN)
        ) {
            dispatch(setOpenSendToPosOptionsModal(false))
        }
    }

    // Handle the initial mount and unmount of the component
    useEffect(() => {
        document.addEventListener('keydown', handleKeyDown, false)

        if (open) {
            document.body.classList.add(UI.classes.MULTIPLE_MODALS_OPEN)
        }

        // cleanup/reset on unmount
        return () => {
            document.body.classList.remove(UI.classes.MULTIPLE_MODALS_OPEN)
            document.removeEventListener('keydown', handleKeyDown, false)
        }
    }, [])

    return open && (
        <div className="modal modal-backdrop modal--xs">
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-body p-4">
                        <div className="container px-1">
                            <button
                                children='Add To An Existing Check'
                                type="button"
                                className="btn btn-primary btn-block mb-4"
                                onClick={() => {
                                    dispatch(setOpenSendToPosOptionsModal(false))
                                    dispatch(setOpenCheckSelectModal(true))
                                }}
                            />
                            <button
                                children='Create A New Check'
                                type="button"
                                className="btn btn-primary btn-block mb-4"
                                onClick={() => {
                                    dispatch(setOpenSendToPosOptionsModal(false))
                                    dispatch(setOpenServerSelectModal(true))
                                }}
                            />
                            <button
                                children='Cancel'
                                type="button"
                                className="btn btn-outline-primary btn-block"
                                onClick={() => dispatch(setOpenSendToPosOptionsModal(false))}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
